import * as React from "react";
import { connect } from "react-redux";
import {
  Container,
  Dropdown,
  Accordion,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { ProductService } from "../../Common/Services/ProductService";
import paginationFactory from "react-bootstrap-table2-paginator";
import _ from "lodash";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
const { SearchBar } = Search;
import { Utils } from "../../Common/Utilis";
import { TransactionService } from "../../Common/Services/TransactionService";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";

class AccountingPeriod extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isSpinner: false,
      locationDetails: {},
      checkedMonths: {},
      htmlItem: [],
      htmlErrorItem: [],
      htmlWarningItem: [],
      searcResult: [],
      selectedcolumn: "Select",
      selectedyear: "",
      selectOptionsYear: [],
      selectOptions: [
        { id: "Select", name: "Select" },
        { id: "Not Used", name: "Not Used" },
        { id: "Active", name: "Active" },
        // { id: "AP Closed", name: "AP Closed" },
        { id: "Closed", name: "Closed" },
      ],
    };
  }
  componentDidMount() {
    this.getYear();
  }

  getYear = () => {
    const currentYear = new Date().getFullYear();
    const selectOptionsYear: any = [];

    for (let i = 0; i < 5; i++) {
      const year = currentYear - i;
      selectOptionsYear.push({ id: year.toString(), name: year.toString() });
    }

    this.setState(
      {
        selectOptionsYear: selectOptionsYear,
        selectedyear: currentYear.toString(),
      },
      () => {
        this.getLocation();
      }
    );
  };

  getLocation = () => {
    let requestlist = { ...this.state.requestlist };
    requestlist.year = parseInt(this.state.selectedyear);
    TransactionService.GetAccountingPeriods(requestlist)
      .then((result: Location[] | null) => {
        if (result && result.length > 0) {
          const processedResult = result.map((row, index) => ({
            ...row,
            _updateTick: 0,
          }));
          this.setState({ searcResult: processedResult, checkedMonths: {} });
          // this.setState({
          //   searcResult:result
          // });
        }
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
      });
  };

  savePeriods = () => {
    const { checkedMonths, selectedyear, selectedcolumn } = this.state;

    const selectedItems: any[] = [];

    for (const month in checkedMonths) {
      const rowMap = checkedMonths[month];
      for (const locationId in rowMap) {
        if (rowMap[locationId]) {
          selectedItems.push({
            locationId: parseInt(locationId),
            month: month,
          });
        }
      }
    }

    if (selectedItems.length === 0) {
      toast.error("No months selected to save.");
      return;
    }

    if (selectedcolumn === "Select") {
      toast.error("No status selected to save.");
      return;
    }

    this.setState({ isSpinner: true });
    const requestPayload = {
      status: selectedcolumn,
      year: selectedyear,
      selectedItems,
    };

    TransactionService.SaveAccountingPeriods(requestPayload)
      .then((res: any) => {
        if (res) {
          toast.success("Accounting periods saved successfully.");
          this.getLocation();
        } else {
          toast.error("Please try again.");
        }
        this.setState({ isSpinner: false });
      })
      .catch((err: any) => {
        toast.error(`Error saving periods: ${err}`);
        this.setState({ isSpinner: false });
      });
  };

  handleSelectedItem1 = (control: any, id: any) => {
    if (control == 2) {
      this.setState({ selectedcolumn: id });
    } else {
      this.setState({ selectedyear: id }, () => {
        this.getLocation();
      });
    }
  };

  handleCheckboxChange = (month: string, locationId: number) => {
    const { checkedMonths } = this.state;
    const updated = { ...checkedMonths };

    if (!updated[month]) updated[month] = {};
    updated[month][locationId] = !updated[month][locationId];

    const updatedData = this.state.searcResult.map((row) => {
      if (row.locationId === locationId) {
        return {
          ...row,
          _updateTick: (row._updateTick || 0) + 1,
        };
      }
      return row;
    });

    this.setState({
      checkedMonths: updated,
      searcResult: updatedData,
    });
  };

  toggleColumnCheckbox = (month: string) => {
    const { checkedMonths, searcResult } = this.state;
    const allChecked = searcResult.every(
      (row) => checkedMonths[month]?.[row.locationId]
    );

    const updated = { ...checkedMonths };
    if (!updated[month]) updated[month] = {};

    const newSearchResult = searcResult.map((row) => {
      updated[month][row.locationId] = !allChecked;

      return {
        ...row,
        _tick: (row._tick || 0) + 1,
      };
    });
    this.setState({
      checkedMonths: updated,
      searcResult: newSearchResult,
    });
  };

  generateMonthColumn = (monthKey: string, monthLabel: string) => {
    const { checkedMonths, searcResult } = this.state;
    const allChecked = searcResult.every(
      (row) => checkedMonths[monthKey]?.[row.locationId]
    );

    return {
      dataField: monthKey,
      text: (
        <div>
          <input
            type="checkbox"
            checked={allChecked}
            onChange={() => this.toggleColumnCheckbox(monthKey)}
          />{" "}
          {monthLabel}
        </div>
      ),
      formatter: (cell: any, row: any) => {
        const isChecked = checkedMonths[monthKey]?.[row.locationId] || false;
        const status = row[monthKey];
        let color = "";
        if (status === "Closed") color = "green";
        else if (status === "Active") color = "red";
        else if (status === "AP Closed") color = "orange";
        else if (status === "Not Used") color = "black";

        return (
          <div>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() =>
                this.handleCheckboxChange(monthKey, row.locationId)
              }
            />{" "}
            <span
              className="ml-1 font-semibold"
              style={{
                color: color,
              }}
            >
              {status}
            </span>
          </div>
        );
      },
    };
  };

  render() {
    const { permissions } = this.props; 
    const hasAddPermission = permissions && permissions['Accounting Period'] ? permissions['Accounting Period'].includes('Change Status') : false;
    
    const customTotal = (from, to, size) => (
      <span className="text-muted">
        Showing {from} to {to} of {size} entries
      </span>
    );
    const options = {
      showTotal: true,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "25",
          value: 25,
        },
        {
          text: "50",
          value: 50,
        },

        {
          text: "All",
          value: this.state.searcResult.length,
        },
      ], // A numeric array is also available. the purpose of above example is custom the text
    };
    const { showSlideout } = this.state;

    // const columns = [
    //     {

    //     dataField: 'code',
    //     text: 'Location',
    //   },
    //   {

    //     dataField: 'jan',
    //     text: 'JAN',
    //   },
    //   {

    //     dataField: 'feb',
    //     text: 'FEB',
    //   },
    //   {

    //     dataField: 'mar',
    //     text: 'MAR',
    //   },
    //   {

    //     dataField: 'apr',
    //     text: 'APR',
    //   },
    //   {

    //     dataField: 'may',
    //     text: 'MAY',
    //   },
    //   {

    //     dataField: 'jun',
    //     text: 'JUN',
    //   },
    //   {

    //     dataField: 'jul',
    //     text: 'JUL',
    //   },
    //   {

    //     dataField: 'aug',
    //     text: 'AUG',

    //   },
    //   {

    //     dataField: 'sep',
    //     text: 'SEP',
    //   },
    //   {

    //     dataField: 'oct',
    //     text: 'OCT',
    //   },
    //   {

    //     dataField: 'nov',
    //     text: 'NOV',
    //   },
    //   {

    //     dataField: 'dec',
    //     text: 'DEC',
    //   }
    // ];

    const columns = [
      {
        dataField: "code",
        text: "Location",
      },
      this.generateMonthColumn("jan", "JAN"),
      this.generateMonthColumn("feb", "FEB"),
      this.generateMonthColumn("mar", "MAR"),
      this.generateMonthColumn("apr", "APR"),
      this.generateMonthColumn("may", "MAY"),
      this.generateMonthColumn("jun", "JUN"),
      this.generateMonthColumn("jul", "JUL"),
      this.generateMonthColumn("aug", "AUG"),
      this.generateMonthColumn("sep", "SEP"),
      this.generateMonthColumn("oct", "OCT"),
      this.generateMonthColumn("nov", "NOV"),
      this.generateMonthColumn("dec", "DEC"),
    ];

    return (
      <>
        <React.Fragment>
          <Container fluid className="body-sec">
            <div className="page-heading underline d-flex  ">
              Accounting Period
            </div>
            <section className="mt-3">
              <ToolkitProvider
                keyField="id"
                data={this.state.searcResult}
                columns={columns}
              >
                {(props) => (
                  <div>
                    <section className="d-flex flex-wrap gap-3 pb-2 mb-2">
                      <div className="col-12 col-md-2">
                        <Form.Label className="font-semibold">Year</Form.Label>
                        <SingleDropdownListWithoutSearch
                          itemList={this.state.selectOptionsYear}
                          handleSelectedItem={this.handleSelectedItem1.bind(
                            this,
                            1
                          )}
                          defaultItem={this.state.selectedyear}
                          defaultText={"Select Filter"}
                          defaultName={this.state.selectedyear}
                          controlID="1"
                          id={"ddlselected"}
                        />
                      </div>

                      <div className="col-12 col-md-2">
                        <Form.Label className="font-semibold">
                          Change Status To
                        </Form.Label>
                        <SingleDropdownListWithoutSearch
                          itemList={this.state.selectOptions}
                          handleSelectedItem={this.handleSelectedItem1.bind(
                            this,
                            2
                          )}
                          defaultItem={this.state.selectedcolumn}
                          defaultText={"Select Filter"}
                          defaultName={this.state.selectedcolumn}
                          controlID="1"
                          id={"ddlselected"}
                        />
                      </div>
                      <div className="col-12 col-md-2 mt-auto">
                        {hasAddPermission&& <Button onClick={this.savePeriods}>Change</Button>}
                      </div>
                    </section>
                    <section className="pb-3">
                      <div className="table-responsive divbottom">
                        <div className="ml-auto transactions-list">
                          <BootstrapTable
                            {...props.baseProps}
                            keyField="rowId"
                            pagination={paginationFactory(options)}
                          />
                        </div>
                      </div>
                    </section>
                  </div>
                )}
              </ToolkitProvider>
              {this.state.isSpinner && (
                <div className="loader-spinner d-flex justify-content-center align-items-center">
                  <Spinner animation="border" variant="success" />
                </div>
              )}
            </section>
          </Container>
        </React.Fragment>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId
});

export default connect(mapStateToProps)(AccountingPeriod);